<template>
    <form v-if="!loading" @submit.prevent="groupUUID ? requestUpdate() : requestCreate()">
        <b-form-group :label="$t('label.name')" label-cols="4" label-align="left">
            <b-form-textarea
                v-model.trim="createForm.name"
                :class="{ 'is-invalid': submitted && !$v.createForm.name.required }"
                autocomplete="off"
            />
            <b-form-invalid-feedback v-if="submitted && !$v.createForm.name.required" class="text-right">
                {{ $t('message.requiredX', [$t('label.name')]) }}
            </b-form-invalid-feedback>
        </b-form-group>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end w-100">
            <b-button type="button" variant="danger" class="mr-2 col-3" :disabled="!status.save" @click="$emit('done')">
                {{ $t('label.cancel') }}
            </b-button>
            <b-button type="submit" variant="info" class="col-3" :disabled="!status.save || !loaded">
                <span v-if="status.save">{{ groupUUID ? $t('label.updateX', []) : $t('label.createX', []) }}</span>
                <b-spinner v-else small />
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center align-items-center m-3">
        <b-spinner class="m-5" variant="info" role="status" />
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { phoneExtGroupMethods } from "@/state/api";
import { PHONE_EXT_GROUP_MODULE } from "@/state/api/phoneExtGroup.state";

export default {
    props: {
        phoneExtUUID: { type: String, required: true },
        groupUUID: { type: String, default: '' },
        sequence: { type: Number, default: 1 },
    },
    validations() {
        return { createForm: { name: { required } } };
    },
    async created() {
        await this.getGroupData();
    },
    data() {
        return {
            submitted: false,
            loading: false,
            loaded: !this.groupUUID,
            createForm: this.defaultForm(),
        };
    },
    methods: {
        ...phoneExtGroupMethods,
        defaultForm() {
            return { uuid: '', name: '', sequence: this.sequence };
        },
        async getGroupData() {
            if (this.groupUUID) {
                this.loading = true;
                await this.getPhoneExtGroup({uuid: this.groupUUID})
                    .then((result) => {
                        if (result?.success) {
                            this.createForm = {
                                uuid: this.data.uuid,
                                name: this.data.name,
                                sequence: this.data.sequence,
                            };
                            this.loaded = true;
                        }
                    });
                this.loading = false;
            }
        },
        requestCreate() {
            if (!this.status.save || !this.loaded) return;
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) return;
            let data = { ...this.createForm, phoneExtUuid: this.phoneExtUUID };
            this.createPhoneExtGroup({data})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) {
                        this.$emit('reload');
                        this.$emit('done');
                    }
                }));
        },
        requestUpdate() {
            if (!this.status.save || !this.loaded) return;
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) return;
            let data = { ...this.createForm, phoneExtUuid: this.phoneExtUUID };
            this.updatePhoneExtGroup({data})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) {
                        this.$emit('reload');
                        this.$emit('done');
                    }
                }));
        },
    },
    computed: {
        ...mapState(PHONE_EXT_GROUP_MODULE, ['status']),
        data() {
            return this.$store.state.api.phoneExtGroup.details;
        },
    },
};
</script>
